import { FileListGalleryItemThumbnailFallback } from './FileListGalleryItemThumbnailFallback';
import { FileListGalleryItemThumbnailReal } from './FileListGalleryItemThumbnailReal';
import { FileAndThumbnail } from './types';

export interface FileListGalleryItemThumbnailProps {
  file: FileAndThumbnail;
}

export function FileListGalleryItemThumbnail(
  props: FileListGalleryItemThumbnailProps
) {
  const { file } = props;

  const thumbnailUrl = resolveThumbnailUrl(file);

  if (thumbnailUrl) {
    return <FileListGalleryItemThumbnailReal thumbnailUrl={thumbnailUrl} />;
  } else {
    return <FileListGalleryItemThumbnailFallback file={file.file} />;
  }
}

function resolveThumbnailUrl(file: FileAndThumbnail): string | null {
  if (file.thumbnail) {
    return file.thumbnail.fileInfos.previewUrl;
  }

  // If a file is an image, just load the file itself if the thumbnail is
  // missing. For other files default to fallback UI.
  switch (file.file.previewMimeType) {
    case 'image/jpeg':
    case 'image/png':
    case 'image/svg+x':
    case 'image/webp':
      return file.file.previewUrl;

    default:
      return null;
  }
}
